import Base from './base'

export default class PublicPeople extends Base {
  async get(searchParams: Record<string, unknown>) {
    const result = await this.api.get('people', { params: searchParams })

    return result.data
  }
}
